import { useEffect } from 'react';
import MODALS from '@constants/modals';
import { useModalDispatch } from '@hooks/useModalProvider';
import { ReactTable } from '@pages/User/components';
import { useDataIsEmpty } from '@pages/User/hooks';
import { useBrandings } from '@queries/fetchBrandings';
import type { PlainAction } from '@root/@types/types';
import { TEMPLATE_STATUSES } from '@root/@types/types';

import { INITIAL_BRANDING_COLS } from '../constants';
import { useBrandingStore } from '../store/branding.store';
import { pickValidBrandingTemplates } from '../utils/get-branding-templates';

import { useBrandingTemplateStore } from './branding-template-selector/branding-templates.store';

export const BrandingPage = () => {
  const { reset } = useBrandingStore((s) => s);
  const { reset: resetTemplates, setBrandingTemplates } = useBrandingTemplateStore((s) => s);

  const { showModal } = useModalDispatch();

  const { data = [], status } = useBrandings();
  const isEmpty = useDataIsEmpty(data, status);

  useEffect(() => {
    reset();
    // eslint-disable-next-line -- just reset the store
  }, []);

  const openBrandingCreator = () => {
    resetTemplates();
    setBrandingTemplates(pickValidBrandingTemplates(data));
    showModal(MODALS.CREATE_BRANDING, {});
  };

  const createEntityAction: PlainAction = {
    key: 'create',
    label: 'New Branding',
    onClick: openBrandingCreator,
  };

  return (
    <ReactTable
      actions={[createEntityAction]}
      columns={INITIAL_BRANDING_COLS}
      columnVisibility={{
        id: false,
        created_by: false,
        last_updated_by: false,
      }}
      createEntityAction={createEntityAction}
      entityName="branding"
      filteredData={data}
      initialFilters={[{ id: 'status', value: TEMPLATE_STATUSES.filter((status) => status !== 'ARCHIVED') }]}
      initialSorting={[{ id: 'created_at', desc: true }]}
      status={status}
      isEmpty={isEmpty}
    />
  );
};
